import axiosClient from "./axiosClient";

const bookingApi = {
  getAll: () => axiosClient.get("/bookings/?page=1&limit=10"),
  getById: (id) => axiosClient.get(`/bookings/${id}`),
  create: (data) => axiosClient.post("/admin/bookings", data),
  update: (id, data) => axiosClient.patch(`/admin/bookings/${id}`, data),
  delete: (id) => axiosClient.delete(`/admin/bookings/${id}`)
};

export default bookingApi;
